const U = (id, w) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=75`;

const IDS = {
  heroHome: "photo-1609971757431-439cf7b4141b",
  heroHomeAlt: "photo-1553455427-c38fa28dc586",
  dining: "photo-1563216225-5d6adc7d9663",
  chauffeur: "photo-1673364432357-f7152f341568",
  executiveDesk: "photo-1612093991429-acd0fc7b1804",
  opera: "photo-1781598965718-7c4bd549f99b",
  grandInterior: "photo-1630145783467-26f953f0b993",
  apartment: "photo-1592229506151-845940174bb0",
  glassDome: "photo-1784115334839-100c9fb8c02d",
  windowView: "photo-1511372843403-757aadf79c6c",
  cafeLaptop: "photo-1537888539464-30b4888d54fc",
};

export const hero = (key) => U(IDS[key], 1800);
export const card = (key) => U(IDS[key], 900);

export const SERVICE_IMG = {
  "private-assistance": "grandInterior",
  "executive-assistance": "executiveDesk",
  "lifestyle-concierge": "dining",
  "travel-events": "chauffeur",
};

export const landingImage = (slug) => {
  if (slug.includes("fashion-week")) return "opera";
  if (slug.includes("-clients")) return "glassDome";
  if (slug.includes("business-travel")) return "executiveDesk";
  if (slug.includes("travel")) return "chauffeur";
  if (slug.includes("chauffeur") || slug.includes("airport-transfer")) return "chauffeur";
  if (slug.includes("experiences")) return "opera";
  if (slug.includes("last-minute")) return "heroHomeAlt";
  if (slug.includes("restaurant")) return "dining";
  if (slug.includes("shopper")) return "grandInterior";
  if (slug.includes("families")) return "apartment";
  if (slug.includes("corporate") || slug.includes("business")) return "cafeLaptop";
  if (slug.includes("executive")) return "windowView";
  if (slug.includes("luxury")) return "opera";
  if (slug.includes("vip") || slug.includes("lifestyle")) return "dining";
  if (slug.includes("concierge")) return "heroHome";
  return "executiveDesk";
};

const ARTICLE_IMG = {
  "paris-airports-cdg-orly-le-bourget-guide": "chauffeur",
  "luxury-experiences-paris-international-visitors": "opera",
  "business-travel-concierge-paris-how-it-works": "executiveDesk",
  "24-hours-in-paris-what-to-delegate": "windowView",
  "private-concierge-cost-paris": "heroHomeAlt",
  "private-concierge-vs-hotel-concierge-paris": "grandInterior",
  "last-minute-restaurant-reservations-paris": "dining",
  "private-shopping-paris-how-it-works": "windowView",
  "what-american-clients-delegate-personal-assistant-paris": "windowView",
  "what-chinese-clients-delegate-personal-assistant-paris": "opera",
  "what-brazilian-clients-delegate-personal-assistant-paris": "grandInterior",
  "personal-assistant-paris-cost-prices": "heroHomeAlt",
  "what-to-delegate-personal-assistant-paris": "executiveDesk",
  "hire-private-assistant-france-guide": "apartment",
  "private-assistant-vs-concierge": "dining",
  "cost-of-no-support-france": "windowView",
  "executive-support-international-leaders": "cafeLaptop",
  "setting-up-business-france-administrative-reality": "glassDome",
  "french-administration-decoded": "heroHome",
  "paris-international-families": "grandInterior",
  "trusted-person-every-country": "opera",
  "discretion-standard-ndas-privacy": "windowView",
  "first-30-days-france": "chauffeur",
};

export const articleImage = (slug) => ARTICLE_IMG[slug] || "heroHome";
